import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useAboutPageData from '../../../cmsHooks/useAboutPageData'

import { FullWidthSection, ContentContainer, Center } from '../../layout'
import { ActionButton, SidePageTextBox } from '../../ui'

const Para = styled.p`
  font-size: 22px;
  margin-top: 20px;
  line-height: 1.4em;
  &:last-of-type {
    margin-bottom: 50px;
  }
`

const Spacer = styled.div`
  height: 100px;
`

const About = (): JSX.Element => {
  const data = useAboutPageData()

  return (
    <FullWidthSection>
      <ContentContainer verticalPadding={'40px'}>
        <Center cross>
          <SidePageTextBox>
            <h1>
              <CMS.Text name="About headline" data={data} />
            </h1>
            <h2>
              <CMS.Text name="Talus headline" data={data} />
            </h2>
            <Para>
              <CMS.Text name="Para 1" data={data} />
            </Para>
            <Para>
              <CMS.Text name="Para 2" data={data} />
            </Para>
            <a href={CMS.getText(data, 'Button link')} target="_blank">
              <ActionButton>
                <CMS.Text name="Button text" data={data} />
              </ActionButton>
            </a>
          </SidePageTextBox>
          <Spacer />
        </Center>
      </ContentContainer>
    </FullWidthSection>
  )
}

export default About
